<template>
    <section class="section quiz quiz--main ">
        <div class="container-medium">
            <h3 class="section__title quiz__title">Вы можете пройти процедуру банкротства</h3>
            <p class="section__subtitle quiz__subtitle">с любой суммой задолженности.</p>
            <p class="subtitle-purple">Когда сумма задолженности <strong>более 200 000 рублей,</strong> то процедура банкротства становится экономически выгодной.</p>

            <div class="row quiz__row">
                <div class="quiz__img">
                    <img src="img/quiz/dollars.png" alt="dollars">
                    <div class="quiz__dots"><img src="img/quiz/dots.png" alt="dots"></div>
                </div>

                <div class="quiz__box">
                    <p class="quiz__box-title">Если вы хотите списать кредитную задолженность законно, правильно и быстро — мы готовы помочь:</p>
                    <ul class="quiz__ul">
                        <li class="quiz__li">Пройти процедуру банкротства может не только юридическое, но и физическое лицо. Основание — Федеральный закон №127-ФЗ «О несостоятельности (банкротстве)».</li>
                        <li class="quiz__li">Списывать долги можно уже с просрочкой от 3 месяцев.</li>
                        <li class="quiz__li">Помогаем избавиться от задолженностей перед МФО, банками, ЖКХ, частными лицами и службой судебных приставов.</li>
                    </ul>
                    <button class="button" @click.prevent="changeTrigger">Пройдите тест. </br>Подходит ли вам банкротство?</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "StartPageQuiz",
  methods: {
    changeTrigger() {
      this.$store.dispatch("viewOrHideStartPage");
    },
  },
};
</script>

<style scoped>
</style>
